import { Guid, Nillable } from '@web/utils';
import { AdminBoxQuantityHistoryReasonType } from '../enums/admin-box-quantity-history-reason-type';
import { AdminBoxQuantityHistoryOrder } from './admin-box-quantity-history-order';

export class AdminBoxQuantityHistoryCollectionItem {
  public constructor(
    private readonly data: {
      change: number;
      createdAt: Date;
      createdBy?: Nillable<string>;
      id: Guid;
      order?: Nillable<AdminBoxQuantityHistoryOrder>;
      quantityAfterChange: number;
      quantityBeforeChange: number;
      reason: AdminBoxQuantityHistoryReasonType;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get change(): number {
    return this.data.change;
  }

  public get absoluteChange(): number {
    return Math.abs(this.data.change);
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get createdBy(): Nillable<string> {
    return this.data.createdBy;
  }

  public get order(): Nillable<AdminBoxQuantityHistoryOrder> {
    return this.data.order;
  }

  public get quantityAfterChange(): number {
    return this.data.quantityAfterChange;
  }

  public get quantityBeforeChange(): number {
    return this.data.quantityBeforeChange;
  }

  public get reason(): AdminBoxQuantityHistoryReasonType {
    return this.data.reason;
  }
}
